import React from 'react'
import { StyledBannerMSJ } from 'components/BannerMSJ/styled'
import PropTypes from 'prop-types'
import { matchColorsBanner } from 'utils/colors'

const BannerMSJ = ({ themeInfos }) => {

  const getLogoMsj = () => {
    const logoMsj = matchColorsBanner(themeInfos.details.colors.banner);

    return logoMsj === '#FFFFFF' ? `/static/logos/msj/msj-blanc.svg` : `/static/logos/msj/msj.svg`;
  }

  return (
    <>
      <StyledBannerMSJ $themeCustom={themeInfos}>
        <p>Propulsé par&nbsp;</p>
        <img
          src={getLogoMsj()}
          alt="logo msj"
          style={{ width: '120px', marginLeft: '2px', paddingBottom: '4px' }}
        />
      </StyledBannerMSJ>
    </>
  )
}

BannerMSJ.propTypes = {
  themeInfos: PropTypes.object,
}

export default BannerMSJ;